// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"TypesCard_mainContainer__2KVOQ","heightIcon":"TypesCard_heightIcon__2WX7e","weightIcon":"TypesCard_weightIcon__efxoA"};